import { render } from "./vue3-slider.vue?vue&type=template&id=a53178c6"
import script from "./vue3-slider.vue?vue&type=script&lang=ts"
export * from "./vue3-slider.vue?vue&type=script&lang=ts"

import "./vue3-slider.vue?vue&type=style&index=0&id=a53178c6&lang=scss"
script.render = render

export default script